import { Translation } from '@ps/web-shared-components';
import React from 'react';

import type {
  DepositContext,
  DepositResult,
  GooglePayNativeResultError
} from '../../../../../../types/Cashier';
import { DepositStatus } from '../../../../../../types/status';
import RejectedCommon from '../RejectedCommon/RejectedCommon';
import RejectedTransaction from '../RejectedTransaction/RejectedTransaction';

import {
  TXTWCL_Please_ensure_that_your_Google_ELL,
  TXTWCL_Your_Google_Pay_deposit_has_be_ELL,
  TXTWCL_Your_Google_Pay_session_has_ti_ELL,
  TXTWCL_Your_transaction_has_been_decl_ELL_1
} from './Rejected.messages.json';

type DepositResultProps = DepositResult & DepositContext;
type GooglePayNativeResultErrorProps = GooglePayNativeResultError & DepositContext;
type Props = DepositResultProps | GooglePayNativeResultErrorProps;

const googlePayErrorMessage = {
  [DepositStatus.GOOGLE_PAY_FAILED]: <Translation {...TXTWCL_Please_ensure_that_your_Google_ELL} />,
  [DepositStatus.GOOGLE_PAY_CANCELED]: (
    <Translation {...TXTWCL_Your_Google_Pay_deposit_has_be_ELL} />
  ),
  [DepositStatus.GOOGLE_PAY_SESSION_TIMEOUT]: (
    <Translation {...TXTWCL_Your_Google_Pay_session_has_ti_ELL} />
  )
};

const Rejected: React.FC<Props> = ({ deposit, status, ...rest }) => {
  const googlePayError = [
    DepositStatus.GOOGLE_PAY_FAILED,
    DepositStatus.GOOGLE_PAY_CANCELED,
    DepositStatus.GOOGLE_PAY_SESSION_TIMEOUT
  ].includes(status);

  return (
    <>
      <RejectedCommon>
        {googlePayError
          ? googlePayErrorMessage[status]
          : !(rest as DepositResultProps).message &&
            status === DepositStatus.REJECTED && (
              <Translation {...TXTWCL_Your_transaction_has_been_decl_ELL_1} />
            )}
      </RejectedCommon>
      {status !== DepositStatus.REJECTED_PEP_HIO_THIRD_PARTY && (
        <RejectedTransaction
          deposit={deposit}
          transactionId={(rest as DepositResultProps).transactionId}
        />
      )}
    </>
  );
};

export default Rejected;
